import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import UserInfo from "@/views/community/components/UserInfo.vue";
export default {
  name: "simulationList",
  components: {
    UserInfo: UserInfo
  },
  data: function data() {
    return {
      searchForm: {
        page: 1,
        size: 20,
        phone: "",
        cityId: ""
      },
      loading: false,
      list: [],
      cityList: [],
      loadingMore: false,
      userInfoLoading: false,
      noMore: false,
      userInfo: {},
      otherHeight: 0,
      flowList: {
        1: {
          text: '限制',
          type: "danger"
        },
        2: {
          text: '普通',
          type: "info"
        },
        3: {
          text: '优质',
          type: "-"
        },
        4: {
          text: '极佳',
          type: "success"
        },
        5: {
          text: '官方精选',
          type: "success"
        }
      }
    };
  },
  watch: {
    "userInfo.id": {
      handler: function handler(nVal) {
        var _this = this;
        if (nVal) {
          this.$nextTick(function () {
            var dom = document.querySelector(".user-info-box");
            _this.otherHeight = dom.clientHeight + 25;
          });
        } else {
          this.otherHeight = 0;
        }
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this2.getCityList();
          case 1:
            _this2.getSimulationData("init");
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this3 = this;
    this.$nextTick(function () {
      var dom = document.querySelector(".simulation-list");
      if (dom) {
        dom.addEventListener("scroll", _this3.handleScroll);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    var dom = document.querySelector(".simulation-list");
    if (dom) {
      dom.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    getCityList: function getCityList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this4.$api.getCityListByPy();
            case 1:
              res = _context2.v;
              _this4.cityList = res.data;
              _this4.searchForm.cityId = "15102233103895305";
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getSimulationData: function getSimulationData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _res$data, result, res, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(type === "search")) {
                _context3.n = 1;
                break;
              }
              _this5.searchForm.page = 1;
              _this5.noMore = false;
              _this5.list = [];
              _this5.loading = true;
              _context3.n = 4;
              break;
            case 1:
              if (!(type === "loadMore")) {
                _context3.n = 3;
                break;
              }
              if (!(_this5.loadingMore || _this5.noMore || _this5.loading)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              _this5.loadingMore = true;
              _this5.searchForm.page += 1;
              _context3.n = 4;
              break;
            case 3:
              _this5.loading = true;
            case 4:
              _context3.p = 4;
              if (!_this5.searchForm.phone) {
                _context3.n = 6;
                break;
              }
              _this5.searchForm.cityId = "";
              _context3.n = 5;
              return _this5.getUserInfo();
            case 5:
              result = _context3.v;
              _context3.n = 7;
              break;
            case 6:
              _this5.userInfo = {};
            case 7:
              _context3.n = 8;
              return _this5.$api.getSimulationList(_this5.searchForm);
            case 8:
              res = _context3.v;
              if (res.data && res.data.list) {
                if (type === "loadMore") {
                  // 加载更多时追加数据
                  if (res.data.list.length) {
                    _this5.list = [].concat(_toConsumableArray(_this5.list), _toConsumableArray(res.data.list));
                  } else {
                    _this5.noMore = true;
                  }
                } else {
                  // 初始加载或搜索时替换数据
                  _this5.list = res.data.list || [];
                  // 如果没有数据，设置noMore为true
                  if (res.data.list.length === 0) {
                    _this5.noMore = true;
                  } else {
                    _this5.noMore = false;
                  }
                  _this5.$forceUpdate(); // 强制更新视图
                }
              }
              if (!((_res$data = res.data) !== null && _res$data !== void 0 && _res$data.list) && res.message) {
                _this5.$message.error(res.message);
              }
              _context3.n = 10;
              break;
            case 9:
              _context3.p = 9;
              _t = _context3.v;
              _this5.$message.error(type === "loadMore" ? "加载更多数据失败" : "获取数据失败");
            case 10:
              _context3.p = 10;
              _this5.loading = false;
              if (type === "loadMore") {
                _this5.loadingMore = false;
                setTimeout(function () {
                  _this5.loadingMore = false;
                }, 200);
              }
              return _context3.f(10);
            case 11:
              return _context3.a(2);
          }
        }, _callee3, null, [[4, 9, 10, 11]]);
      }))();
    },
    handleScroll: function handleScroll(e) {
      // 检查是否滚动到底部
      var scrollElement = e.target;
      var scrollHeight = scrollElement.scrollHeight;
      var scrollTop = scrollElement.scrollTop;
      var clientHeight = scrollElement.clientHeight;

      // 当滚动到距离底部50px时触发加载更多
      if (scrollTop + clientHeight >= scrollHeight - 50 && !this.loadingMore && !this.noMore) {
        this.getSimulationData("loadMore");
      }
    },
    getUserInfo: function getUserInfo() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this6.userInfoLoading = false;
              return _context5.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(resolve) {
                  var res;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        _context4.n = 1;
                        return _this6.$api.getSimulationUserInfo({
                          phone: _this6.searchForm.phone
                        });
                      case 1:
                        res = _context4.v;
                        _this6.userInfoLoading = true;
                        _this6.userInfo = res.data;
                        resolve(res.data.id);
                      case 2:
                        return _context4.a(2);
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee5);
      }))();
    },
    //合并展示数组
    manageArr: function manageArr(oneArr, twoArr) {
      return _toConsumableArray(new Set([].concat(_toConsumableArray(oneArr), _toConsumableArray(twoArr)))).join("、");
    },
    toLink: function toLink(row) {
      var link = "".concat(window.location.origin, "/community/").concat(row.secureToken, "?id=").concat(row.id);
      window.open(link, "_blank");
    },
    setCity: function setCity(row) {
      var _row$city, _row$ipCity;
      if (row !== null && row !== void 0 && (_row$city = row.city) !== null && _row$city !== void 0 && _row$city.includes(row.ipCity)) {
        return row.city;
      } else if (row !== null && row !== void 0 && (_row$ipCity = row.ipCity) !== null && _row$ipCity !== void 0 && _row$ipCity.includes(row.ipCity)) {
        return row.ipCity;
      }
      return row.city;
    }
  }
};